<script>
	import Gallery from '../States/Gallery';
	import Helper from '../Models/Helper';

	let active = false;
	let list = [];
	let top = 0;

	function uri(group, item) {
		item = Helper.zeroPad(item, 3);
		const path = `${group.path}/mop${group.number}x${item}.jpg`;
		return path;
	}

	function generateList(api) {
		const content = [];
		const percentages = [1, 33, 66, 99];
		for (let category = 1; category <= 25; category++) {
			const group = Math.round(Helper.random(0, api.length - 1));
			const current = api[group];
			current.preview = [];
			for (let percentage of percentages) {
				const index = Math.ceil(current.count * (percentage / 100));
				const thing = uri(current, index);
				current.preview.push(thing);
			}

			content.push(current);
		}

		list = content;
	}

	function group(group) {
		top = window.scrollY;
		$Gallery.group = group;
		$Gallery.view = 'group';
	}

	function galleryChange(gallery) {
		active = Helper.is(gallery.api) && (gallery.view == 'category');
		if (active && !Helper.is(list)) generateList(gallery.api);
		if (active) window.scrollTo({top});
	}

	Gallery.subscribe(gallery => galleryChange(gallery));
</script>

<style>
	div.category {
		display: none;
	}

	div.category.active {
		display: block;
	}

	div.group {
		display: flex;
		flex-direction: row;
		flex-wrap: wrap;
		margin-bottom: 3em;
	}

	div.group > div {
		width: 50%;
		height: 10em;
		background: #000;
	}

	div.group > div > img {
		object-fit: cover;
		object-position: center center;
		width: 100%;
		height: 100%;
	}
</style>

<div class="category" class:active="{active}">
	{#each list as item}
		<div class="group" on:click="{group(item)}">
			{#each item.preview as path}
				<div>
					<img src="{path}"/>
				</div>
			{/each}
		</div>
	{/each}
</div>